import React, { forwardRef, PropsWithChildren, useRef } from 'react';
import classNames from 'classnames';
import { mergeRefs } from 'react-merge-refs';

import { ScrollbarProps } from './interfaces';

import useStyles from './style';

const Scrollbar = forwardRef<HTMLDivElement, PropsWithChildren<ScrollbarProps>>(
  (
    {
      className,
      id,
      children,
      onScroll,
      disableKeyScrolling = false,
      shiftThumbStyle = 'keepBoxShadow',
    },
    ref
  ) => {
    const classes = useStyles();

    const scrollRef = useRef<Nullable<HTMLDivElement>>(null);

    return (
      <div
        className={classNames('viboScrollbar', shiftThumbStyle, classes.viboScrollbar, className)}
        onScroll={e => {
          onScroll?.(e.currentTarget.scrollTop, e);
        }}
        tabIndex={0}
        id={id}
        ref={mergeRefs([scrollRef, ref])}
        {...(disableKeyScrolling
          ? {
              onKeyDown: e => e.preventDefault(),
              onKeyUp: e => e.preventDefault(),
            }
          : {})}
      >
        {children}
      </div>
    );
  }
);

export default Scrollbar;
